import { render, staticRenderFns } from "./StudentHasDebts.vue?vue&type=template&id=689992e0&"
import script from "./StudentHasDebts.vue?vue&type=script&lang=js&"
export * from "./StudentHasDebts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports